import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import ElDefectsForm from "../../components/common/form/ElDefectsForm";
import { DefectCounter } from "../../components/ui/buttons/DefectCounter";
import {
  DefectType,
  StringSize,
  initialDefects,
} from "../../types/stringerTypes";
import {
  getLatestCellyieldsFromSixAM,
  defectTypeIdMap,
} from "../../services/cellyieldService";

// Umkehr-Map: defectTypeId → DefectType
const defectIdToType: Record<number, DefectType> = Object.entries(
  defectTypeIdMap
).reduce((acc, [defect, id]) => {
  acc[id] = defect as DefectType;
  return acc;
}, {} as Record<number, DefectType>);

export default function PreLamiElCellYield() {
  const [initialCounts, setInitialCounts] =
    useState<Record<StringSize, Record<DefectType, number>>>();

  const initDefects = (): Record<DefectType, number> =>
    initialDefects.reduce((acc, defect) => {
      acc[defect] = 0;
      return acc;
    }, {} as Record<DefectType, number>);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getLatestCellyieldsFromSixAM();

        const mapped: Record<StringSize, Record<DefectType, number>> = {
          4: initDefects(),
          5: initDefects(),
          6: initDefects(),
          8: initDefects(),
        };

        data.forEach((entry) => {
          const size = entry.stringType as StringSize;
          const defect = defectIdToType[entry.defectTypeId];
          if (size && defect) {
            mapped[size][defect] = (mapped[size][defect] || 0) + 1;
          }
        });

        setInitialCounts(mapped);
      } catch (err) {
        console.error("❌ Fehler beim Laden:", err);
      }
    };

    fetchData();
  }, []);

  const renderCounter = (
    defect: DefectType,
    count: number,
    onChange: (delta: number) => void,
    disabled: boolean
  ) => (
    <DefectCounter
      label={defect}
      count={count}
      onChange={onChange}
      disabled={disabled}
    />
  );

  return (
    <Box sx={{ marginTop: 15 }}>
      {initialCounts && (
        <ElDefectsForm
          renderCounter={renderCounter}
          showDetailsOnly={false}
          initialCounts={initialCounts}
        />
      )}
    </Box>
  );
}
